import PropTypes from "prop-types";
import React from "react";

// Filters the loaded product list as you type (see ProductList); Enter just keeps the term
// instead of flone's stock form that navigated to "#".
const ShopSearch = ({ value, onChange }) => {
    return (
        <div className="sidebar-widget">
            <h4 className="pro-sidebar-title">Search </h4>
            <div className="pro-sidebar-search mb-50 mt-25">
                <form className="pro-sidebar-search-form" role="search" onSubmit={(e) => e.preventDefault()}>
                    <input
                        type="text"
                        placeholder="Search here..."
                        aria-label="Search products"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    <button type="submit" aria-label="Search">
                        <i className="pe-7s-search" />
                    </button>
                </form>
            </div>
        </div>
    );
};

ShopSearch.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
};

export default ShopSearch;